export enum ProvidersSorting {
    Overall = 1,
    Price,
    Reviews
}
